import * as constants from '../constants/cities';
import {pagination} from '../../config/settings';
import * as _ from 'lodash';

export const initialState = {
  item: null,
  list: [],
  totalCount: 0,
  loading: false,
  params: {
    ordering: 'id', limit: pagination.limit, offset: 0, search: null
  },
  pagesCount: 1,
  page: 1,
};

export default (state =  _.cloneDeep(initialState), action) => {
  switch (action.type) {
    case constants.GET_CITIES:
    case constants.GET_CITY:
    case constants.UPDATE_CITY:
    case constants.REMOVE_CITY:
      return {
        ...state,
        loading: true
      };
    case constants.GET_CITIES_ERROR:
    case constants.GET_CITY_ERROR:
    case constants.UPDATE_CITY_ERROR:
    case constants.REMOVE_CITY_ERROR:
      return {
        ...state,
        loading: false,
        clearing: false,
      };
    case constants.GET_CITIES_SUCCESS:
      return {
        ...state,
        loading: false,
        clearing: false,
        list: action.payload,
        item: null,
        totalCount: action.totalCount,
        pagesCount: Math.ceil(action.totalCount / pagination.limit)
      };
    case constants.GET_CITY_SUCCESS:
      return {
        ...state,
        loading: false,
        list: [],
        item: action.payload,
      };
    case constants.EDIT_CITY:
      return {
        ...state,
        item: action.data,
      };
    case constants.CITIES_CHANGE_PARAMS:
      return {
        ...state,
        params: action.data ?? _.cloneDeep(initialState.params),
      };
    case constants.CITIES_UPDATE_PARAMS:
      return {
        ...state,
        params: action.data !== null ? _.merge(state.params, action.data) : _.cloneDeep(initialState.params)
      };
    case constants.CITIES_RESET_PARAMS:
      return {
        ...state,
        clearing: false,
        params: _.cloneDeep(initialState.params)
      };
    case constants.CITIES_CHANGE_PAGE:
      return {
        ...state,
        page: +action.data,
      };
    case constants.CITIES_CLEAR:
      return {
        ...state,
        clearing: true,
        totalCount: 0,
        pagesCount: 1,
        page: 1,
        item: null,
        list: [],
      };

    default:
      return state;
  }
};